var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "basic-container",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-scrollbar",
                    {
                      staticStyle: { height: "606px", "padding-right": "15px" },
                    },
                    [
                      _c("treeselect", {
                        ref: "treeselect",
                        attrs: {
                          maxHeight: 600,
                          options: _vm.treeData,
                          cacheOptions: false,
                          alwaysOpen: "",
                          noChildrenText: "没有子节点",
                          noOptionsText: "暂无数据",
                          noResultsText: "暂无结果",
                          loadingText: "加载中",
                          searchPromptText: "暂无数据,可以输入关键字进行查询",
                          normalizer: _vm.normalizer,
                          appendToBody: true,
                          "load-options": _vm.Isasync
                            ? _vm.asyncOptions
                            : _vm.loadOptions,
                          async: _vm.Isasync,
                          placeholder: "输入关键字进行过滤",
                        },
                        on: {
                          select: _vm.getNodeData,
                          "search-change": _vm.treeSearchChange,
                          open: _vm.itemopen,
                          close: _vm.itemClose,
                        },
                        nativeOn: {
                          keydown: function ($event) {
                            return _vm.assetTreeKeydownFun.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 18 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        "label-position": _vm.labelPosition,
                        model: _vm.form,
                        rules: _vm.rules,
                        "label-width": "80px",
                      },
                    },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "box-card",
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { header: "渠道信息" },
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "渠道名称", prop: "name" } },
                                [
                                  _c("el-input", {
                                    attrs: { readonly: "" },
                                    model: {
                                      value: _vm.form.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "name", $$v)
                                      },
                                      expression: "form.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "注册手机",
                                    prop: "loginMobile",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { readonly: "" },
                                    model: {
                                      value: _vm.form.loginMobile,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "loginMobile", $$v)
                                      },
                                      expression: "form.loginMobile",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "登录名", prop: "loginName" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { readonly: "" },
                                    model: {
                                      value: _vm.form.loginName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "loginName", $$v)
                                      },
                                      expression: "form.loginName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "渠道属性",
                                    prop: "channelAttr",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.channelAttr,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "channelAttr", $$v)
                                        },
                                        expression: "form.channelAttr",
                                      },
                                    },
                                    _vm._l(
                                      _vm.channelAttrList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.name,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "渠道来源",
                                    prop: "channelFrom",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.channelFrom,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "channelFrom", $$v)
                                        },
                                        expression: "form.channelFrom",
                                      },
                                    },
                                    _vm._l(
                                      _vm.channelFromList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.name,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "渠道地区",
                                    prop: "cityCode",
                                  },
                                },
                                [
                                  _c("avue-cascader", {
                                    attrs: {
                                      dic: _vm.areaList,
                                      props: _vm.props,
                                      "show-all-levels": false,
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.form.cityCode,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "cityCode", $$v)
                                      },
                                      expression: "form.cityCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "状态", prop: "status" } },
                                [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-value": 1,
                                      "inactive-value": 0,
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.form.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "status", $$v)
                                      },
                                      expression: "form.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "停用状态",
                                    prop: "insureAuthority",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { readonly: "" },
                                    model: {
                                      value: _vm.form.insureAuthority,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "insureAuthority",
                                          $$v
                                        )
                                      },
                                      expression: "form.insureAuthority",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "可用产品",
                                    prop: "insureTypes",
                                  },
                                },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value: _vm.form.insureTypes,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "insureTypes", $$v)
                                        },
                                        expression: "form.insureTypes",
                                      },
                                    },
                                    _vm._l(
                                      _vm.insureTypes,
                                      function (itemData, index) {
                                        return _c(
                                          "el-checkbox",
                                          {
                                            key: index,
                                            attrs: {
                                              label: itemData.type,
                                              disabled: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(itemData.name) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-card",
                        {
                          staticClass: "box-card",
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { header: "联系人" },
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "联系人",
                                    prop: "contactPerson",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { readonly: "" },
                                    model: {
                                      value: _vm.form.contactPerson,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "contactPerson", $$v)
                                      },
                                      expression: "form.contactPerson",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "联系手机",
                                    prop: "contactPersonMobile",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { readonly: "" },
                                    model: {
                                      value: _vm.form.contactPersonMobile,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "contactPersonMobile",
                                          $$v
                                        )
                                      },
                                      expression: "form.contactPersonMobile",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "备注", prop: "remark" } },
                                [
                                  _c("el-input", {
                                    attrs: { readonly: "" },
                                    model: {
                                      value: _vm.form.remark,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "remark", $$v)
                                      },
                                      expression: "form.remark",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-card",
                        {
                          staticClass: "box-card",
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { header: "结算信息" },
                        },
                        _vm._l(_vm.form.settleAccounts, function (ref, index) {
                          var userName = ref.userName
                          var idNo = ref.idNo
                          var bankName = ref.bankName
                          var cardNo = ref.cardNo
                          return _c(
                            "div",
                            { key: index },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "结算人",
                                        prop: "settleUserName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { readonly: "" },
                                        model: {
                                          value: userName,
                                          callback: function ($$v) {
                                            userName = $$v
                                          },
                                          expression: "userName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "身份证号",
                                        prop: "settleUserIdNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { readonly: "" },
                                        model: {
                                          value: idNo,
                                          callback: function ($$v) {
                                            idNo = $$v
                                          },
                                          expression: "idNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "开户行",
                                        prop: "settleBankName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { readonly: "" },
                                        model: {
                                          value: bankName,
                                          callback: function ($$v) {
                                            bankName = $$v
                                          },
                                          expression: "bankName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "银行卡号",
                                        prop: "settleBankCardNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { readonly: "" },
                                        model: {
                                          value: cardNo,
                                          callback: function ($$v) {
                                            cardNo = $$v
                                          },
                                          expression: "cardNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }